export default "__VITE_ASSET__paDkI_Nu__"